// extracted by mini-css-extract-plugin
export default {"loading":"lottery_loading__z2c9W","pcWrap":"lottery_pcWrap__+ILJc"};